<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">เพิ่มวิชา</h2>
      </div>
      <SubjectForm @createSubject="createSubject" />
    </div>
    <el-dialog
      title="กำลังอัปโหลดข้อมูล..."
      :visible.sync="dialogProgress"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="25vh"
      :width="widthMax < 767.98 ? '80%' : null"
      class="text-center padding-top-10"
    >
      <el-progress
        type="circle"
        :percentage="progress"
        :width="widthMax < 767.98 ? 200 : 250"
        :color="[
          { color: '#ff8f8c', percentage: 30 },
          { color: '#ffb800', percentage: 60 },
          { color: '#04cc24', percentage: 80 },
        ]"
      ></el-progress>
    </el-dialog>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import SubjectForm from "@/components/subject/SubjectForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    SubjectForm,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      courseId: "",
      loading: false,
      dialogProgress: false,
      progress: 0,
      widthMax: window.innerWidth,
    };
  },
  mounted() {
    this.setParams();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.widthMax = window.innerWidth;
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
        }
      }
    },
    createSubject(data) {
      this.progress = 0;
      this.dialogProgress = true;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("name", data.subjectName);
      formData.append("instructor", data.instructor);

      formData.append("description", data.courseDescription);
      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.subjectDistanceDate[0],
          close: data.subjectDistanceDate[1],
        })
      );
      formData.append(
        "totalStudyTime",
        JSON.stringify({
          hours: data.timeLearn.hour != null ? data.timeLearn.hour : 0,
          minute: data.timeLearn.min != null ? data.timeLearn.min : 0,
        })
      );

      let activity = {
        topic: false,
        preTest: true,
        descussion: false,
        assignment: false,
        postTest: false,
      };

      formData.append("activity", JSON.stringify(activity));

      formData.append("courseId", this.courseId);

      data.courseAudioFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("attach", item.raw);
        }
      });

      data.courseDocumentFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("document", item.raw);
        }
      });

      formData.append("index", data.number);

      let interval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 2;
        }
        setTimeout(() => {
          if (this.progress < 95) {
            this.progress += 1;
          }
        }, 1000);
      }, 1500);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`subject`, formData, config)
        .then((res) => {
          if (res.data.success) {
            clearInterval(interval);
            this.progress = 95;
            setTimeout(() => {
              this.progress = 100;
              setTimeout(() => {
                this.dialogProgress = false;
                this.$router.push(
                  `/manage/course/update?courseId=${this.courseId}`
                );
              }, 500);
            }, 500);
          } else {
            this.dialogProgress = false;
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.dialogProgress = false;
          this.alertCatchError(e);
          console.log("updateMessage error", e);
        });
    },
  },
};
</script>
